import { initializePermissions } from "./InitializePermissions"
export const combineUserAndAdminPermissions = (currentUserPermissions, adminPermissions) => {
    const allPermissions = initializePermissions(adminPermissions, 'create');
    const userPermissions = initializePermissions(currentUserPermissions, 'edit');

    const mergedPermissions = allPermissions.map((module) => {
        const foundModule = userPermissions.find((u) => u.module === module.module);

        if (!foundModule) {
            return module;
        }

        const mergedSubmodules = module.submodules.map((sub) => {
            const foundSub = foundModule.submodules.find(
                (uSub) => uSub.submodule === sub.submodule
            );
            return foundSub ? foundSub : sub;
        });

        return {
            ...module,
            isSelected: true,
            submodules: mergedSubmodules,
        };
    });

    return mergedPermissions
}